import { ChangeDetectionStrategy, Component, ElementRef, Injector, OnInit } from '@angular/core';
import { slideInAnimation } from './animations';
import { ActivationEnd, ChildrenOutletContexts, Router, RouterOutlet } from '@angular/router';
import { CoreService, ServiceList } from 'core';
import { AppDetailsModel } from 'core/lib/services/models/app-details.model';
const isMobile = (): boolean => {
  const ua = navigator.userAgent;
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
};
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit {
  title = 'hybrid-platform';
  // links = [{
  //   icon: 'house',
  //   path: '/home',
  //   id: 'home'
  // },
  // {
  //   icon: 'magnifying-glass',
  //   path: '/search',
  //   id: 'search',
  // },
  // {
  //   icon: 'map-location-dot',
  //   path: '/map',
  //   id: "map"
  // },]
  links = [
    {
      icon: 'people-line',
      path: '/home',
      id: 'queue'
    },
    {
      icon: "circle-info",
      path: '',
      link: "https://getinline.lafleetweek.org",
      id: "info"
    }
  ]
  hideFooter: boolean = false;
  constructor(private contexts: ChildrenOutletContexts, private injectorObj: Injector, private elementRef: ElementRef, private router: Router) {
    // this.injectorObj.get(CoreService).boot()

    if (!isMobile()) {
      alert("Mobile device required. Application will now end.");
      document.body.innerHTML = `<div style="width:100%; max-width:690px; margin:0px 0px -24px 0px; padding:0; font-family:Arial, Helvetica, sans-serif; color:#1f2933;">
<div style="margin:0 0 14px 0; padding:18px 20px; background-color:#fff8e8; border:1px solid #f0d58a; border-left:6px solid #ffb738; border-radius:14px;">
<table role="presentation" style="width:100%; border-collapse:collapse;">
	<tbody>
		<tr>
			<td style="width:52px; vertical-align:top; padding:0 14px 0 0;">
			<div style="width:40px; height:40px; background-color:#102045; border-radius:18px; text-align:center;"><img alt="Mobile device required" src="https://d2fcq8dd5wp28g.cloudfront.net/OW-circle-exclamation.png" style="width:32px; height:32px; margin-top:4px;" /></div>
			</td>
			<td style="vertical-align:top; text-align:left;">
			<div style="margin:0; font-size:18px; line-height:1.5; font-weight:700; color:#7a5a00;">The Digital Queue is a mobile-only application. If you would like to access the queue, please use a mobile device.</div>
			</td>
		</tr>
	</tbody>
</table>
</div>

<div style="margin:0; padding:22px 20px; background-color:#102045; border:1px solid #f3c2b8; border-left:6px solid #ffb738; border-radius:14px;">
<table role="presentation" style="width:100%; border-collapse:collapse;">
	<tbody>
		<tr>
			<td style="width:52px; vertical-align:top; padding:0 14px 0 0;">
			<div style="width:40px; height:40px; background-color:#ffb738; border-radius:18px; text-align:center;"><img alt="Digital Queue Information" src="https://d2fcq8dd5wp28g.cloudfront.net/OW-circle-info.png" style="width:32px; height:32px; margin-top:4px;" /></div>
			</td>
			<td style="vertical-align:top; text-align:left;">
			<div style="margin:0 0 6px 0; font-size:20px; line-height:1.3; font-weight:700; color:#ffb738;">Digital Queue Information</div>

			<div style="font-size:16px; line-height:1.6; color:#ffffff;">Digital Queue reservations are <span style="font-weight:700; text-decoration:underline;">free</span>, but <span style="font-weight:700; text-decoration:underline;">space is limited</span> and offered on a <span style="font-weight:700; text-decoration:underline;">first-come, first-served basis</span>.<br />
			<br />
			Reservations are available for <span style="font-weight:700; text-decoration:underline;">same-day visits only</span> and must be claimed <span style="font-weight:700; text-decoration:underline;">in person</span>.<br />
			<br />
			Your reservation window is <span style="font-weight:700; text-decoration:underline;">not your ship tour time</span>. It is the time you should join the <span style="font-weight:700; text-decoration:underline;">in-person boarding queue</span> to go through security and board a shuttle bus to the active Navy ships.<br />
			<br />
			A Digital Queue reservation allows you to enter the <span style="font-weight:700; text-decoration:underline;">security checkpoint line</span>, but it <span style="font-weight:700; text-decoration:underline;">does not guarantee a ship tour</span>.</div>
			</td>
		</tr>
	</tbody>
</table>
</div>
</div>`
      // Using 'as never' tells TypeScript this code path effectively ends the app
      throw new Error("Device compatibility error: Desktop detected.") as any;
    }
    this.router.events.subscribe(data => {
      if (data instanceof ActivationEnd) {

        const footerData = data.snapshot.data?.['footer'];
        this.hideFooter = footerData?.show ?? false
      }
    });
  }
  ngOnInit(): void {
    this.injectorObj.get(CoreService).appLoadedSubject.subscribe((appData) => {
      console.log(appData)
      this.elementRef.nativeElement.style.setProperty('--accent-color', (appData as AppDetailsModel).web_app_primary_color)
      this.elementRef.nativeElement.style.setProperty('--ion-color-primary', (appData as AppDetailsModel).web_app_primary_color)
      // this.injectorObj.get(CoreService).preloadData([ServiceList.Tour, ServiceList.SiteSection, ServiceList.Exhibit])
      // this.elementRef.nativeElement.style.setProperty('--secondary-info', '#696969')
      this.injectorObj.get(CoreService).preloadData([ServiceList.DigitalQueue])

    })
    // this.injectorObj.get(CoreService).preloadData([ServiceList.Tour, ServiceList.Category, ServiceList.SiteSection])
  }
  // getState(outlet: RouterOutlet) {
  //   // console.log(outlet)
  //   // Changing the activatedRouteData.state triggers the animation
  //   return outlet.activatedRouteData['state'];
  // }
  // hideBottomBar(): boolean {
  //   const footerData  = this.contexts.getContext('primary')?.route?.snapshot?.data?.['footer']
  //   return footerData?.show??false
  //   // let hideFor = ['splash']
  //   // let hide = true
  //   // hideFor.forEach((hx) => {
  //   //   if (this.router.url == hx) {
  //   //     hide = true
  //   //   }
  //   // })
  //   // return hide
  // }
}
